import { call, put, select } from 'redux-saga/effects'
import CommentActions from 'Redux/CommentRedux'
import { VideoSelectors } from 'Redux/VideoRedux'
import { CanvasSelectors } from 'Redux/CanvasRedux'
import { CommentRespTransform } from 'Transforms/Comment'
import { BuildErrorMsg } from './ApiHelpers'

export function * onVideoCommentsRequest (api, action) {
  const resp = yield call(api.getVideoVersionComments, action.videoId)
  if (resp.ok) {
    yield put(CommentActions.commentsListSuccess(
      CommentRespTransform(resp.data)))
  } else {
    yield put(
      CommentActions.commentsListFailure(BuildErrorMsg(resp))
    )
  }
}

export function * onCreateCommentRequest (api, action) {
  const points = yield select(CanvasSelectors.points)
  const resp = yield call(
    api.createComment,
    { ...action.createParams, points: { data: points } }
  )
  if (resp.ok) {
    yield put(CommentActions.commentsCreateSuccess(resp.data))
    // yield put(CommentActions.commentsSetCurrent(resp.data))
    yield put(CommentActions.commentsListRequest(action.createParams.video_id))
  } else {
    yield put(
      CommentActions.commentsCreateFailure(BuildErrorMsg(resp))
    )
  }
}

export function * onSearchCommentsRequest (api, action) {
  const videoVersionIds = yield select(VideoSelectors.videoVersionIds)
  const resp = yield call(
    api.searchVideoVersionComments, videoVersionIds, action.searchText)
  if (resp.ok) {
    yield put(CommentActions.commentsSearchSuccess(resp.data))
  } else {
    yield put(
      CommentActions.commentsSearchFailure(BuildErrorMsg(resp))
    )
  }
}

export function * onDeleteCommentsRequest (api, action) {
  const resp = yield call(api.deleteComment, action.commentId)
  if (resp.ok) {
    yield put(CommentActions.commentsDeleteSuccess(resp.data))
    yield put(CommentActions.commentsListRequest(action.videoId))
  } else {
    yield put(
      CommentActions.commentsDeleteFailure(BuildErrorMsg(resp))
    )
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/CommentSagas.js